import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { initAuthDefaultFlow } from './auth-flows/default-flow';

// Types

/**
 * Auth plugin for Nuxt using Auth0.
 *
 * @param {Context} context
 * @param {Inject} inject
 */
export var auth = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, inject) {
    var app, $config, route, auth;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          app = _ref.app, $config = _ref.$config, route = _ref.route;
          /** To support multiple auth flows
           *  and have a switch statement here to determine which flow to use based on config
           */
          auth = initAuthDefaultFlow({
            app: app,
            $config: $config,
            route: route
          });
          _context.next = 4;
          return auth.initAuth();
        case 4:
          inject('auth', auth);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function auth(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default auth;